var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg300301Dn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009EFF",
    d: "M36.876,45.229 C35.553,47.783 32.534,46.112 33.804,43.647 C34.882,41.552 37.472,40.285 37.472,40.285 C37.472,40.285 37.922,43.201 36.876,45.229 Z M23.665,45.229 C22.342,47.783 19.323,46.112 20.593,43.647 C21.671,41.552 24.261,40.285 24.261,40.285 C24.261,40.285 24.711,43.201 23.665,45.229 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    opacity: 0.4,
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9C9C9",
    strokeWidth: 1.4,
    d: "M6.06 29.503L45.192 29.503M11.689 39.708L50.821 39.708M4.561 24.401L43.519 24.401M9.762 34.606L48.72 34.606M6.06 9.093L45.192 9.093M11.689 19.298L50.821 19.298M4.561 3.99L43.519 3.99M10.29 14.16L49.248 14.16M4.561 45.097L43.519 45.097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg300301Dn);
export default __webpack_public_path__ + "static/media/300_301dn.8811be143137f1198123318e78fd97de.svg";
export { ForwardRef as ReactComponent };